import React  from 'react'
import loading from './Maelstorm.gif'

const Loading =()=> {
 
    return (
      <div>
        <div className='text-center p-2' >
        <img src={loading} alt="loading"  />
      </div> </div>
    )
  
}

export default Loading
